(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 3405:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(5690);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4666);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5407);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6246);
/* harmony import */ var _components_loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8083);





(0,_builder__WEBPACK_IMPORTED_MODULE_3__/* .registerComponents */ .Q)();
var Page = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_1__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(258), __webpack_require__.e(832), __webpack_require__.e(31)]).then(__webpack_require__.bind(__webpack_require__, 5448));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5448)
            ];
        }
    }
});
var Article = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_1__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(258), __webpack_require__.e(832), __webpack_require__.e(454), __webpack_require__.e(359)]).then(__webpack_require__.bind(__webpack_require__, 9454));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9454)
            ];
        }
    }
});
var NotFound = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_1__["default"])(function() {
    return __webpack_require__.e(/* import() */ 200).then(__webpack_require__.bind(__webpack_require__, 1200));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1200)
            ];
        }
    }
});
var PageRoot = function(props) {
    var page = props.page, model = props.model, upNextArticle = props.upNextArticle, relatedArticles = props.relatedArticles;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
    if (model === "page") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Page, {
            page: page
        });
    }
    if (model === "article") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Article, {
            upNextArticle: upNextArticle,
            relatedArticles: relatedArticles,
            page: page
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotFound, {});
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PageRoot);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [334,749,774,888,179], function() { return __webpack_exec__(3405); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);